import { render, staticRenderFns } from "./BusinessesPage.vue?vue&type=template&id=6455d10e&scoped=true"
import script from "./BusinessesPage.vue?vue&type=script&lang=js"
export * from "./BusinessesPage.vue?vue&type=script&lang=js"
import style0 from "./BusinessesPage.vue?vue&type=style&index=0&id=6455d10e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6455d10e",
  null
  
)

export default component.exports